import { toTitle } from "@src/helpers/text-helper";
import { ChartAction } from "@src/pages/ab-test-explore/component/charts/action";
import { FormInstance } from "antd";
import React, { useState } from "react";
import { ConsoleSqlOutlined, MoreOutlined } from "@ant-design/icons";
import { uniq } from "lodash";

export const MoreAction: React.FC<{
    form: FormInstance;
    options?: any[];
    item?: ("export-csv" | "download-csv" | "job-meta" | "rendered-query" | "json-query" | "create_exploration")[];
}> = ({ form, options, item }) => {
    return (
        <ChartAction
            tabKey={"intelligence-search"}
            tabName={toTitle("Intelligence Search")}
            form={form}
            dropdownChildren={<MoreOutlined className="text-lg font-bold" />}
            builtinMenuItemKeys={uniq([...["export-csv", "download-csv", "job-meta"], ...(item ?? [])]) as any[]}
            extendedMenuItems={options}
        />
    );
};

export const MoreActionQuery: React.FC<{
    form: FormInstance;
    options?: any[];
}> = ({ form, options }) => {
    return (
        <ChartAction
            trigger={["click"]}
            tabKey={"intelligence-search"}
            tabName={toTitle("Intelligence Search")}
            form={form}
            dropdownChildren={
                <div className="cursor-pointer">
                    <ConsoleSqlOutlined className="text-lg font-bold" />
                </div>
            }
            builtinMenuItemKeys={["rendered-query", "json-query"]}
            extendedMenuItems={options}
        />
    );
};
